import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify.js'
import router from './libs/router.js'
import store from './libs/store.js'

import { WebMIDI } from './vanilla/scripts/midiconnection.js';
import { BLEMIDIUtils } from './vanilla/scripts/blemidiutils.js';
import { EWI4000sDriver } from './vanilla/scripts/ewi4000sdriver.js';

Vue.config.productionTip = false

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, {
  id: 'UA-116678332-1',
  router
})

import Vuex from 'vuex'
import './registerServiceWorker'
Vue.use(Vuex)

Vue.mixin({
  store: function() {
    return store
  },
  data: function() {
    return {
      globalVar: {
        libs:{
          wm: new WebMIDI(),
          ewi4ksd: new EWI4000sDriver(),
          bleUtil: new BLEMIDIUtils()
        },
        config: {
          midi_deveice: {
            input: null,
            output: null
          },
        }
      }
    }
  },
})

new Vue({
  vuetify,
  router,
  render: h => h(App),
  created: function() {}
}).$mount('#app')

